module.exports = __webpack_public_path__ + "static/media/twilio-mark-red.a06174e2.png";